export const MODULES_OUTCOME = 'outcome/module'
export const MODULES_OUTCOME_LIST = 'outcome/module/'
